// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings (redesign) — /settings.
   Scoped under .st-*; relies on dashboard-redesign.css for the shell
   tokens and the shared .rf-btn / .rf-serif / .rf-num / .rf-spacer. */

.st-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  overflow: hidden;
  /* .rf-content top-aligns rather than capping height — bind to the
     viewport minus the 64px top bar and the .rf-app gutter + border so
     the section nav stays put and only the panel scrolls. */
  height: calc(100vh - 76px);
}

/* ---------------- section nav ---------------- */
.st-nav {
  width: 224px;
  flex-shrink: 0;
  border-right: 1px solid #e2dcd0;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #fbf9f5;
  overflow-y: auto;
}
.st-nav-eyebrow {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #bdb6a7;
  padding: 6px 12px 4px;
}
.st-navitem {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font: 500 13.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
  text-align: left;
  width: 100%;
}
.st-navitem:hover {
  background: #f2ede2;
}
.st-navitem.is-active {
  background: #fff;
  color: #191714;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.1);
}
.st-navitem svg {
  font-size: 16px;
  color: #bdb6a7;
  flex-shrink: 0;
}
.st-navitem.is-active svg {
  color: var(--rf-brand);
}
.st-navitem-n {
  margin-left: auto;
  font-size: 11px;
  color: #bdb6a7;
  font-variant-numeric: tabular-nums;
}
.st-nav-note {
  margin: 10px 12px 0;
  font-size: 11px;
  line-height: 1.5;
  color: #a29b8d;
}

/* ---------------- panel ---------------- */
.st-body {
  flex-grow: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 22px 28px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.st-head {
  /* App.css styles a bare <header> globally (bold, centered) — reset it */
  margin: 0;
  text-align: left;
  font-weight: 400;
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}
.st-head-main {
  min-width: 0;
}
.st-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 25px;
  font-weight: 400;
  line-height: 1.15;
  color: #191714;
  margin: 0;
}
.st-lede {
  font-size: 12.5px;
  color: #6f6a60;
  margin: 3px 0 0;
  max-width: 62ch;
  line-height: 1.55;
}

/* read-only banner for a role with settings:read but not settings:manage */
.st-readonly {
  display: flex;
  gap: 10px;
  padding: 10px 13px;
  border-radius: 10px;
  background: #f9f1de;
  border: 1px solid #ecdcb4;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--rf-brand-deep);
}
.st-readonly b {
  font-weight: 700;
}

.st-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  padding: 16px 18px;
}
.st-card-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 3px;
}
.st-card-title {
  font-size: 14.5px;
  font-weight: 600;
  color: #191714;
}
.st-card-meta {
  font-size: 11.5px;
  color: #a29b8d;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.st-card-help {
  font-size: 12px;
  color: #8b8477;
  margin: 0 0 13px;
  line-height: 1.5;
  max-width: 62ch;
}

/* ---------------- fees ---------------- */
.st-grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 14px;
}
.st-fee-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
}
.st-fee-input {
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-grow: 1;
  min-width: 0;
  max-width: 220px;
  border-bottom: 1.5px solid #e7e3da;
  padding-bottom: 4px;
}
.st-fee-input:focus-within {
  border-bottom-color: var(--rf-brand-lite);
}
.st-fee-fix {
  font-size: 15px;
  color: #a29b8d;
}
.st-fee-value {
  flex-grow: 1;
  min-width: 0;
  border: none;
  background: none;
  outline: none;
  padding: 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 27px;
  line-height: 1.1;
  color: #191714;
  font-variant-numeric: tabular-nums;
}
.st-fee-value:disabled {
  color: #6f6a60;
}
.st-dirty {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  padding-bottom: 3px;
}
.st-dirty-note {
  font-size: 11px;
  color: #b0872f;
  white-space: nowrap;
}
.st-btn-sm {
  height: 28px;
  padding: 0 11px;
  font-size: 12px;
  border-radius: 7px;
}

/* ---------------- price lists ---------------- */
/* delivery_fee and sash_prices are stored as one comma-separated string.
   The legacy form made you type that string by hand and told you off in
   red when it didn't parse; here each price is its own chip. */
.st-prices {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.st-price {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 7px 5px 11px;
  border-radius: 8px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  color: var(--rf-brand-deep);
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.st-price.is-readonly {
  padding-right: 11px;
}
.st-x {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 5px;
  background: none;
  color: var(--rf-brand-lite);
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.st-x:hover {
  background: var(--rf-brand-edge);
  color: #7d332b;
}
.st-x:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ---------------- add row ---------------- */
.st-add {
  display: flex;
  gap: 8px;
  margin-top: 13px;
}
.st-input {
  flex-grow: 1;
  min-width: 0;
  height: 34px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  padding: 0 11px;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  background: #fdfcfa;
  outline: none;
}
.st-input:focus {
  border-color: var(--rf-brand-lite);
  background: #fff;
}
.st-input.is-narrow {
  flex-grow: 0;
  width: 130px;
}
.st-add .rf-btn {
  flex-shrink: 0;
}

/* ---------------- type rows ---------------- */
/* The legacy screen put the categories in three separate cards and made
   you flip one into "edit mode" before clicking types in a fourth card to
   file them. The categories a type belongs to now sit on the type. */
.st-rows {
  display: flex;
  flex-direction: column;
  border: 1px solid #f0ece3;
  border-radius: 11px;
  overflow: hidden;
}
.st-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #f0ece3;
  background: #fff;
}
.st-row:last-child {
  border-bottom: none;
}
.st-row:hover {
  background: #fdfbf6;
}
.st-row-name {
  min-width: 0;
  flex-grow: 1;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  overflow-wrap: anywhere;
}
.st-row-name small {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: #a29b8d;
  margin-top: 1px;
}
.st-flags {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.st-flag {
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid #e7e3da;
  background: #fff;
  color: #a29b8d;
  font: 600 10.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
}
.st-flag:hover:not(:disabled) {
  border-color: #d8cfb8;
  color: #6f6a60;
}
.st-flag.is-on {
  background: var(--rf-brand-tint);
  border-color: #d8c9a4;
  color: var(--rf-brand);
}
.st-flag:disabled {
  cursor: default;
}
.st-flag.is-on:disabled {
  opacity: 1;
}
.st-flag:disabled:not(.is-on) {
  opacity: 0.45;
}
.st-row-acts {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.st-mini {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: none;
  background: none;
  color: #bdb6a7;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.st-mini:hover {
  background: #f4f1ea;
  color: #191714;
}
.st-mini.is-danger:hover {
  background: #f7ebe9;
  color: #a8483e;
}
.st-mini:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.st-row.is-confirming {
  background: #fdf6f5;
}
.st-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.st-confirm-t {
  font-size: 11.5px;
  color: #7d332b;
  white-space: nowrap;
}
.st-btn-danger {
  border: none;
  background: #a8483e;
  color: #fff;
}
.st-btn-danger:hover:not(:disabled) {
  background: #8f3c33;
}
.st-btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ---------------- printers ---------------- */
.st-printer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border-bottom: 1px solid #f0ece3;
  background: #fff;
}
.st-printer:last-child {
  border-bottom: none;
}
.st-printer:hover {
  background: #fdfbf6;
}
.st-printer-ic {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 9px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  color: var(--rf-brand);
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.st-printer-main {
  min-width: 0;
  flex-grow: 1;
}
.st-printer-name {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  overflow-wrap: anywhere;
}
.st-printer-sub {
  font-size: 11.5px;
  color: #a29b8d;
  margin-top: 1px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.st-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #bdb6a7;
  display: inline-block;
}
.st-dot.is-on {
  background: #4d7a52;
}
.st-dot.is-off {
  background: #a8483e;
}
.st-badge {
  padding: 3px 9px;
  border-radius: 999px;
  background: #eaf1e9;
  border: 1px solid #cfe0cd;
  color: #3f6046;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ---------------- states ---------------- */
.st-state {
  padding: 26px 8px;
  text-align: center;
  font-size: 12.5px;
  color: #8b8477;
  line-height: 1.6;
}
.st-state b {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4a453c;
  margin-bottom: 2px;
}
.st-state .rf-btn {
  margin-top: 11px;
}
.st-skel {
  height: 34px;
  border-radius: 9px;
  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);
  background-size: 300% 100%;
  animation: st-shimmer 1.3s linear infinite;
  margin-bottom: 8px;
}
@keyframes st-shimmer {
  from {
    background-position: 150% 0;
  }
  to {
    background-position: -150% 0;
  }
}

@media (max-width: 1000px) {
  .st-nav {
    width: 178px;
  }
  .st-body {
    padding-left: 16px;
    padding-right: 16px;
  }
}
@media (max-width: 720px) {
  .st-page {
    flex-direction: column;
    overflow: visible;
    height: auto;
  }
  .st-nav {
    width: auto;
    border-right: none;
    border-bottom: 1px solid #e2dcd0;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px 16px;
  }
  .st-nav-eyebrow,
  .st-nav-note {
    display: none;
  }
  .st-navitem {
    width: auto;
  }
  .st-row {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/settings-redesign.css"],"names":[],"mappings":"AAAA;;sEAEsE;;AAEtE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB;;4DAE0D;EAC1D,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gEAAgE;EAChE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,wEAAwE;EACxE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;;+DAE+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8DAA8D;EAC9D,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;;qEAEqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gEAAgE;EAChE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Settings (redesign) — /settings.\n   Scoped under .st-*; relies on dashboard-redesign.css for the shell\n   tokens and the shared .rf-btn / .rf-serif / .rf-num / .rf-spacer. */\n\n.st-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  overflow: hidden;\n  /* .rf-content top-aligns rather than capping height — bind to the\n     viewport minus the 64px top bar and the .rf-app gutter + border so\n     the section nav stays put and only the panel scrolls. */\n  height: calc(100vh - 76px);\n}\n\n/* ---------------- section nav ---------------- */\n.st-nav {\n  width: 224px;\n  flex-shrink: 0;\n  border-right: 1px solid #e2dcd0;\n  padding: 16px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: #fbf9f5;\n  overflow-y: auto;\n}\n.st-nav-eyebrow {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n  padding: 6px 12px 4px;\n}\n.st-navitem {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font: 500 13.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n  text-align: left;\n  width: 100%;\n}\n.st-navitem:hover {\n  background: #f2ede2;\n}\n.st-navitem.is-active {\n  background: #fff;\n  color: #191714;\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.1);\n}\n.st-navitem svg {\n  font-size: 16px;\n  color: #bdb6a7;\n  flex-shrink: 0;\n}\n.st-navitem.is-active svg {\n  color: var(--rf-brand);\n}\n.st-navitem-n {\n  margin-left: auto;\n  font-size: 11px;\n  color: #bdb6a7;\n  font-variant-numeric: tabular-nums;\n}\n.st-nav-note {\n  margin: 10px 12px 0;\n  font-size: 11px;\n  line-height: 1.5;\n  color: #a29b8d;\n}\n\n/* ---------------- panel ---------------- */\n.st-body {\n  flex-grow: 1;\n  min-width: 0;\n  overflow-y: auto;\n  padding: 22px 28px 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.st-head {\n  /* App.css styles a bare <header> globally (bold, centered) — reset it */\n  margin: 0;\n  text-align: left;\n  font-weight: 400;\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n.st-head-main {\n  min-width: 0;\n}\n.st-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 25px;\n  font-weight: 400;\n  line-height: 1.15;\n  color: #191714;\n  margin: 0;\n}\n.st-lede {\n  font-size: 12.5px;\n  color: #6f6a60;\n  margin: 3px 0 0;\n  max-width: 62ch;\n  line-height: 1.55;\n}\n\n/* read-only banner for a role with settings:read but not settings:manage */\n.st-readonly {\n  display: flex;\n  gap: 10px;\n  padding: 10px 13px;\n  border-radius: 10px;\n  background: #f9f1de;\n  border: 1px solid #ecdcb4;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--rf-brand-deep);\n}\n.st-readonly b {\n  font-weight: 700;\n}\n\n.st-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  padding: 16px 18px;\n}\n.st-card-head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 3px;\n}\n.st-card-title {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #191714;\n}\n.st-card-meta {\n  font-size: 11.5px;\n  color: #a29b8d;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.st-card-help {\n  font-size: 12px;\n  color: #8b8477;\n  margin: 0 0 13px;\n  line-height: 1.5;\n  max-width: 62ch;\n}\n\n/* ---------------- fees ---------------- */\n.st-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 14px;\n}\n.st-fee-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n}\n.st-fee-input {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  flex-grow: 1;\n  min-width: 0;\n  max-width: 220px;\n  border-bottom: 1.5px solid #e7e3da;\n  padding-bottom: 4px;\n}\n.st-fee-input:focus-within {\n  border-bottom-color: var(--rf-brand-lite);\n}\n.st-fee-fix {\n  font-size: 15px;\n  color: #a29b8d;\n}\n.st-fee-value {\n  flex-grow: 1;\n  min-width: 0;\n  border: none;\n  background: none;\n  outline: none;\n  padding: 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 27px;\n  line-height: 1.1;\n  color: #191714;\n  font-variant-numeric: tabular-nums;\n}\n.st-fee-value:disabled {\n  color: #6f6a60;\n}\n.st-dirty {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-shrink: 0;\n  padding-bottom: 3px;\n}\n.st-dirty-note {\n  font-size: 11px;\n  color: #b0872f;\n  white-space: nowrap;\n}\n.st-btn-sm {\n  height: 28px;\n  padding: 0 11px;\n  font-size: 12px;\n  border-radius: 7px;\n}\n\n/* ---------------- price lists ---------------- */\n/* delivery_fee and sash_prices are stored as one comma-separated string.\n   The legacy form made you type that string by hand and told you off in\n   red when it didn't parse; here each price is its own chip. */\n.st-prices {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n.st-price {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 7px 5px 11px;\n  border-radius: 8px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  color: var(--rf-brand-deep);\n  font-size: 13px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n.st-price.is-readonly {\n  padding-right: 11px;\n}\n.st-x {\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 5px;\n  background: none;\n  color: var(--rf-brand-lite);\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.st-x:hover {\n  background: var(--rf-brand-edge);\n  color: #7d332b;\n}\n.st-x:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ---------------- add row ---------------- */\n.st-add {\n  display: flex;\n  gap: 8px;\n  margin-top: 13px;\n}\n.st-input {\n  flex-grow: 1;\n  min-width: 0;\n  height: 34px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  padding: 0 11px;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  background: #fdfcfa;\n  outline: none;\n}\n.st-input:focus {\n  border-color: var(--rf-brand-lite);\n  background: #fff;\n}\n.st-input.is-narrow {\n  flex-grow: 0;\n  width: 130px;\n}\n.st-add .rf-btn {\n  flex-shrink: 0;\n}\n\n/* ---------------- type rows ---------------- */\n/* The legacy screen put the categories in three separate cards and made\n   you flip one into \"edit mode\" before clicking types in a fourth card to\n   file them. The categories a type belongs to now sit on the type. */\n.st-rows {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #f0ece3;\n  border-radius: 11px;\n  overflow: hidden;\n}\n.st-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border-bottom: 1px solid #f0ece3;\n  background: #fff;\n}\n.st-row:last-child {\n  border-bottom: none;\n}\n.st-row:hover {\n  background: #fdfbf6;\n}\n.st-row-name {\n  min-width: 0;\n  flex-grow: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  overflow-wrap: anywhere;\n}\n.st-row-name small {\n  display: block;\n  font-size: 11px;\n  font-weight: 400;\n  color: #a29b8d;\n  margin-top: 1px;\n}\n.st-flags {\n  display: flex;\n  gap: 5px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n.st-flag {\n  padding: 3px 9px;\n  border-radius: 999px;\n  border: 1px solid #e7e3da;\n  background: #fff;\n  color: #a29b8d;\n  font: 600 10.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.st-flag:hover:not(:disabled) {\n  border-color: #d8cfb8;\n  color: #6f6a60;\n}\n.st-flag.is-on {\n  background: var(--rf-brand-tint);\n  border-color: #d8c9a4;\n  color: var(--rf-brand);\n}\n.st-flag:disabled {\n  cursor: default;\n}\n.st-flag.is-on:disabled {\n  opacity: 1;\n}\n.st-flag:disabled:not(.is-on) {\n  opacity: 0.45;\n}\n.st-row-acts {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.st-mini {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: none;\n  background: none;\n  color: #bdb6a7;\n  font-size: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.st-mini:hover {\n  background: #f4f1ea;\n  color: #191714;\n}\n.st-mini.is-danger:hover {\n  background: #f7ebe9;\n  color: #a8483e;\n}\n.st-mini:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n.st-row.is-confirming {\n  background: #fdf6f5;\n}\n.st-confirm {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.st-confirm-t {\n  font-size: 11.5px;\n  color: #7d332b;\n  white-space: nowrap;\n}\n.st-btn-danger {\n  border: none;\n  background: #a8483e;\n  color: #fff;\n}\n.st-btn-danger:hover:not(:disabled) {\n  background: #8f3c33;\n}\n.st-btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ---------------- printers ---------------- */\n.st-printer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 13px;\n  border-bottom: 1px solid #f0ece3;\n  background: #fff;\n}\n.st-printer:last-child {\n  border-bottom: none;\n}\n.st-printer:hover {\n  background: #fdfbf6;\n}\n.st-printer-ic {\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  color: var(--rf-brand);\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.st-printer-main {\n  min-width: 0;\n  flex-grow: 1;\n}\n.st-printer-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  overflow-wrap: anywhere;\n}\n.st-printer-sub {\n  font-size: 11.5px;\n  color: #a29b8d;\n  margin-top: 1px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.st-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #bdb6a7;\n  display: inline-block;\n}\n.st-dot.is-on {\n  background: #4d7a52;\n}\n.st-dot.is-off {\n  background: #a8483e;\n}\n.st-badge {\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: #eaf1e9;\n  border: 1px solid #cfe0cd;\n  color: #3f6046;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ---------------- states ---------------- */\n.st-state {\n  padding: 26px 8px;\n  text-align: center;\n  font-size: 12.5px;\n  color: #8b8477;\n  line-height: 1.6;\n}\n.st-state b {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a453c;\n  margin-bottom: 2px;\n}\n.st-state .rf-btn {\n  margin-top: 11px;\n}\n.st-skel {\n  height: 34px;\n  border-radius: 9px;\n  background: linear-gradient(90deg, #f2efe8 25%, #f8f6f1 50%, #f2efe8 75%);\n  background-size: 300% 100%;\n  animation: st-shimmer 1.3s linear infinite;\n  margin-bottom: 8px;\n}\n@keyframes st-shimmer {\n  from {\n    background-position: 150% 0;\n  }\n  to {\n    background-position: -150% 0;\n  }\n}\n\n@media (max-width: 1000px) {\n  .st-nav {\n    width: 178px;\n  }\n  .st-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n@media (max-width: 720px) {\n  .st-page {\n    flex-direction: column;\n    overflow: visible;\n    height: auto;\n  }\n  .st-nav {\n    width: auto;\n    border-right: none;\n    border-bottom: 1px solid #e2dcd0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 10px 16px;\n  }\n  .st-nav-eyebrow,\n  .st-nav-note {\n    display: none;\n  }\n  .st-navitem {\n    width: auto;\n  }\n  .st-row {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
